import { BASE_IMPORT_DATA } from "@/Modals/WebDataManagement/MasterData/BaseImport/baseImportData";
import GenderModal from "@/Modals/WebDataManagement/MasterData/Genders/Modal";
import MasterDataBaseTable from "../MasterDataBaseTable";
import React from "react";
import { columns } from "./Columns";
import { gendersMasterDataApi } from "@/apis/apis";

export default function GendersPage() {
  return (
    <MasterDataBaseTable
      label="Gender"
      apiURL={gendersMasterDataApi}
      columns={columns()}
      useLocalizationContent
      ModalComponent={GenderModal}
      importData={BASE_IMPORT_DATA.GENDERS}
      enableStatus={false}
      enableSortData={true}
    />
  );
}
